export default {
  name: "Blue-light",
  dark: false,
  scheme: "md-blue-500-scheme",
  primary: "#2196f3"
};
